import React, { useEffect, useRef } from 'react'
import 'ol/ol.css'
import Map from 'ol/Map'
import View from 'ol/View'
import TileLayer from 'ol/layer/Tile'
import OSM from 'ol/source/OSM'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import { fromLonLat } from 'ol/proj'
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style'

interface MapWithMarkerProps {
  latitude: number
  longitude: number
}

export const MapWithMarker: React.FC<MapWithMarkerProps> = ({
  latitude,
  longitude
}) => {
  const mapRef = useRef<Map | null>(null)
  const mapElementRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (latitude && longitude && mapElementRef.current) {
      if (mapRef.current) {
        mapRef.current.setTarget()
        mapRef.current = null
      }

      const currentCoords = fromLonLat([longitude, latitude])

      const locationMarker = new Feature({
        geometry: new Point(currentCoords)
      })

      locationMarker.setStyle(
        new Style({
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({ color: 'rgba(51, 153, 255, 0.8)' }),
            stroke: new Stroke({ color: 'white', width: 2 })
          })
        })
      )

      const vectorSource = new VectorSource({
        features: [locationMarker]
      })

      const vectorLayer = new VectorLayer({
        source: vectorSource
      })

      const newMap = new Map({
        target: mapElementRef.current,
        layers: [
          new TileLayer({
            source: new OSM()
          }),
          vectorLayer
        ],
        view: new View({
          center: currentCoords,
          zoom: 15
        })
      })
      mapRef.current = newMap

      return () => {
        if (newMap) {
          newMap.setTarget()
        }
        mapRef.current = null
      }
    } else if (mapRef.current) {
      mapRef.current.setTarget()
      mapRef.current = null
    }
  }, [latitude, longitude])

  return (
    <div
      ref={mapElementRef}
      id='map'
      className='h-64 w-full border border-border-default rounded-lg overflow-hidden'
    />
  )
}
